// useNavigationGuard.ts
import { useCallback } from 'react';

import { useBlocker } from './useBlocker';

export function useNavigationGuard(isDirty: boolean, message?: string) {
  const handleConfirm = useCallback(
    () => window.confirm(message || '変更内容が破棄されますが、よろしいですか？'),
    [message]
  );

  useBlocker(isDirty, handleConfirm);
}
